module.exports = __webpack_public_path__ + "static/media/goal-overview.2bfec984.svg";